module.exports = __webpack_public_path__ + "img/core-bg2.c8000681.jpg";